export default "__VITE_ASSET__CrghIaj3__"